var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoyImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 71.921,
    viewBox: "0 0 60 71.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25060",
    "data-name": "Group 25060",
    transform: "translate(-232 -195.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_158_6",
    "data-name": "Component 158 \\u2013 6",
    transform: "translate(232 208.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42503",
    "data-name": "Path 42503",
    d: "M30,0A29.753,29.753,0,0,1,60,29.5,29.753,29.753,0,0,1,30,59,29.753,29.753,0,0,1,0,29.5,29.753,29.753,0,0,1,30,0Z",
    fill: "#ddb456"
  })), /*#__PURE__*/React.createElement("g", {
    id: "boy",
    transform: "translate(239.72 195.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165129",
    "data-name": "Path 165129",
    d: "M170.991,476.9c-7.588,0-9.836,1.233-10.187,1.849a4.155,4.155,0,0,1-.686,1.722,2.636,2.636,0,0,1-1.37.8c-.686.036-1.37-.581-1.826-.362s-1.142,1.5-1.142,1.5l-3.6,1.776h35.744s-6.165-2.393-7.588-3.644c0,0-1.142-1.486-.737-2.285.018.019-.931-1.359-8.607-1.359Z",
    transform: "translate(-147.637 -423.053)",
    fill: "#ed1f25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165130",
    "data-name": "Path 165130",
    d: "M223.621,491.9c1.23,2.429,5.3,4.115,7.9,4.115,0,0-4.742.272-6.165-.888a5.775,5.775,0,0,1-1.739-3.226Z",
    transform: "translate(-210.454 -436.185)",
    fill: "#a81a24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25047",
    "data-name": "Group 25047",
    transform: "translate(3.672 28.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165131",
    "data-name": "Path 165131",
    d: "M152.633,278.683s-.579-1.922-3.477-3.118-3.987.6-4.18,2.592,2.056,7.033,4.233,7.885a2.893,2.893,0,0,0,3.407-.725l.018-6.635h0Z",
    transform: "translate(-144.964 -275.18)",
    fill: "#fc8f7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165132",
    "data-name": "Path 165132",
    d: "M154.591,293.616v2.012s-.9-2.321-1.44-2.285-.316,1.558-.509,2.084-.966-.036-1.142-1.759.984-1.7.984-1.7-1.282-3.082-2.845-2.194c-1.581.888-.667,5-.667,5s-2.161-3.9-1.721-5.329c.456-1.433,1.791-1.541,3.987-.182a10.439,10.439,0,0,1,2.9,3.517c.158.308.316.581.456.833Z",
    transform: "translate(-146.923 -286.669)",
    fill: "#db7b6e",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165133",
    "data-name": "Path 165133",
    d: "M186.666,319.924V321.3c-.333-.653-1.177-2.23-1.581-1.813-.491.507-.228,1.45-.649,2.084s-1-1.106-.667-2.266,1.686-.708,2.091-.362a1.487,1.487,0,0,1,.316.344,6.015,6.015,0,0,1,.491.634Z",
    transform: "translate(-178.997 -313.157)",
    fill: "#fc8f7a",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25048",
    "data-name": "Group 25048",
    transform: "translate(34.051 28.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165134",
    "data-name": "Path 165134",
    d: "M396.651,280.293s.579-1.922,3.477-3.118,3.987.6,4.18,2.592-2.056,7.033-4.233,7.885a2.893,2.893,0,0,1-3.407-.725l-.018-6.635h0Z",
    transform: "translate(-396.65 -276.79)",
    fill: "#fc8f7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165135",
    "data-name": "Path 165135",
    d: "M396.66,295.216v2.012s.9-2.321,1.44-2.285.316,1.558.509,2.084.966-.036,1.142-1.759-.984-1.7-.984-1.7,1.282-3.082,2.845-2.194c1.581.888.667,5,.667,5s2.161-3.9,1.721-5.329c-.456-1.433-1.791-1.541-3.987-.182a10.439,10.439,0,0,0-2.9,3.517c-.158.308-.316.581-.456.833Z",
    transform: "translate(-396.659 -288.27)",
    fill: "#db7b6e",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165136",
    "data-name": "Path 165136",
    d: "M396.66,321.524V322.9c.333-.653,1.177-2.23,1.581-1.813.491.507.228,1.45.649,2.084s1-1.106.667-2.266-1.686-.708-2.091-.363a1.486,1.486,0,0,0-.316.344,6.024,6.024,0,0,0-.491.634Z",
    transform: "translate(-396.659 -314.758)",
    fill: "#fc8f7a",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_165137",
    "data-name": "Path 165137",
    d: "M341.543,492.031c-1.721-.471-3.882-1.124-3.882-1.124a10.656,10.656,0,0,1-5.761,1.033c2.056-.617,4.075-1.088,5.744-3.97-.4.8.737,2.285.737,2.285A16.9,16.9,0,0,0,341.543,492.031Z",
    transform: "translate(-305.665 -432.744)",
    fill: "#a81a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165138",
    "data-name": "Path 165138",
    d: "M242.8,486.047a2.007,2.007,0,0,0-1.563.526c-.474.617.4,1.233.4,1.233S242.536,487.516,242.8,486.047Z",
    transform: "translate(-225.82 -431.057)",
    fill: "#a81a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165139",
    "data-name": "Path 165139",
    d: "M351.11,487.429s1.054-.308,1.528.308-.4,1.233-.4,1.233S351.373,488.879,351.11,487.429Z",
    transform: "translate(-322.556 -432.204)",
    fill: "#a81a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165140",
    "data-name": "Path 165140",
    d: "M258.238,410.231V400.08l-5.708.708-5.708-.708v10.151a2.512,2.512,0,0,1-1.212,2.338s1.159,1.7,6.938,1.7,6.938-1.7,6.938-1.7a2.508,2.508,0,0,1-1.247-2.338Z",
    transform: "translate(-229.79 -355.803)",
    fill: "#fc8f7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165141",
    "data-name": "Path 165141",
    d: "M266.925,414.05v7.868a5.556,5.556,0,0,1-3.619,1.831c-3.742.29-6.8-4.314-7.816-6.054V414.07l5.708.708,5.726-.725Z",
    transform: "translate(-238.477 -368.033)",
    fill: "#7c5639",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165142",
    "data-name": "Path 165142",
    d: "M204.816,160.591c-.018.363-.07.871-.158,1.5a21.271,21.271,0,0,1-2.177,6.635c-2.018,4.143-3.091,6.347-5.539,8.334a14.82,14.82,0,0,1-5.017,2.652c-.189.022-.47.049-.807.055-3.89.07-6.813-2.662-8.345-4.095-2.371-2.216-3.459-4.369-4.846-7.108,0,0-1.6-3.239-1.458-4.967a9.218,9.218,0,0,0-.07-2.5c-.053-.326-.123-.689-.228-1.088-.333-1.2-.579-1.178-.879-2.23-.474-1.722.123-1.976,0-4.64-.14-2.919-.474-3.608.228-5.456a10.865,10.865,0,0,1,3.584-4.314,19.113,19.113,0,0,1,11.382-3.752c1.51,0,11.452.235,14.964,8.067,2.652,5.874-.14,11.892-.632,12.907Z",
    transform: "translate(-167.779 -127.789)",
    fill: "#fc8f7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165143",
    "data-name": "Path 165143",
    d: "M185.795,511.857s-2.74.091-3.935-1.142c0,0,.686-1.287,1.142-1.5A3.333,3.333,0,0,0,185.795,511.857Z",
    transform: "translate(-173.734 -451.338)",
    fill: "#a81a24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25050",
    "data-name": "Group 25050",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165144",
    "data-name": "Path 165144",
    d: "M159.44,62.445a4.369,4.369,0,0,0,.649-2.357,13.44,13.44,0,0,0-1.51-5.076,10.151,10.151,0,0,0-2.916-3.862,8.841,8.841,0,0,0-2.3-1.142,12.727,12.727,0,0,0,1.475-.943c.053-.036.176-.254.035-.254-.614.036-1.23.091-1.879.072-1.072-.072-2.091-.78-3.126-1.051a7.194,7.194,0,0,0-2.758-.235,4.982,4.982,0,0,0-2.828-2.194,14.526,14.526,0,0,0-5.638-.725,54.21,54.21,0,0,0-5.673.852c-1.107.163-2.214.29-3.319.453-1.019.163-2.828.49-3.654-.4-.123-.127-.4.127-.4.29a2.308,2.308,0,0,0,.333,1.051,15.944,15.944,0,0,0-4.11,1.577,12.245,12.245,0,0,0-5.3,5.166c-.088.2.088.254.246.163.246-.163.456-.326.7-.526a10.617,10.617,0,0,0-2.266,3.082,5.518,5.518,0,0,0-.614,3.173,8.354,8.354,0,0,0,.984,2.647c-.158.254-.281.49-.421.744-.791,1.469,1.019,3.209,1.844,4.224a27.719,27.719,0,0,1,3.442,6.073c.491,1.015.984,2.031,1.44,3.046a21.272,21.272,0,0,0,.984,2.41c.123.2.421-.163.421-.29-.035-.562-.088-1.106-.158-1.7-.035-1.5-.123-3.01-.211-4.513a14.441,14.441,0,0,1,.123-3.788,8.486,8.486,0,0,1,1.019-2.448c.176-.163.333-.29.527-.453.826-.689,1.721-1.306,2.6-1.9.4-.254.772-.49,1.159-.725a21.566,21.566,0,0,1,4.812.907c3.952,1.142,6.657.2,10.961-.617a26.608,26.608,0,0,1,3.126-.49c.176.2.333.4.456.526.579.562,1.159,1.051,1.756,1.577.544.49,1.072,1.142,1.633,1.74a7.872,7.872,0,0,1,.7,1.867,13,13,0,0,1,.123,3.788c-.088,1.469-.176,3.01-.211,4.513-.053.562-.123,1.106-.158,1.7,0,.127.3.49.421.29a17,17,0,0,0,.984-2.41c.456-1.015.984-2.031,1.44-3.046a27.721,27.721,0,0,1,3.442-6.073c.826-1.015,2.635-2.737,1.844-4.224a1.481,1.481,0,0,0-.228-.49Z",
    transform: "translate(-114.534 -44.654)",
    fill: "#563629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165145",
    "data-name": "Path 165145",
    d: "M159.44,62.445a4.369,4.369,0,0,0,.649-2.357,13.44,13.44,0,0,0-1.51-5.076,10.151,10.151,0,0,0-2.916-3.862,8.841,8.841,0,0,0-2.3-1.142,12.727,12.727,0,0,0,1.475-.943c.053-.036.176-.254.035-.254-.614.036-1.23.091-1.879.072-1.072-.072-2.091-.78-3.126-1.051a7.194,7.194,0,0,0-2.758-.235,4.982,4.982,0,0,0-2.828-2.194,14.526,14.526,0,0,0-5.638-.725,54.21,54.21,0,0,0-5.673.852c-1.107.163-2.214.29-3.319.453-1.019.163-2.828.49-3.654-.4-.123-.127-.4.127-.4.29a2.308,2.308,0,0,0,.333,1.051,15.944,15.944,0,0,0-4.11,1.577,12.245,12.245,0,0,0-5.3,5.166c-.088.2.088.254.246.163.246-.163.456-.326.7-.526a10.617,10.617,0,0,0-2.266,3.082,5.518,5.518,0,0,0-.614,3.173,8.354,8.354,0,0,0,.984,2.647c-.158.254-.281.49-.421.744-.791,1.469,1.019,3.209,1.844,4.224a27.719,27.719,0,0,1,3.442,6.073c.491,1.015.984,2.031,1.44,3.046a21.272,21.272,0,0,0,.984,2.41c.123.2.421-.163.421-.29-.035-.562-.088-1.106-.158-1.7-.035-1.5-.123-3.01-.211-4.513a14.441,14.441,0,0,1,.123-3.788,8.486,8.486,0,0,1,1.019-2.448c.176-.163.333-.29.527-.453.826-.689,1.721-1.306,2.6-1.9.4-.254.772-.49,1.159-.725a21.566,21.566,0,0,1,4.812.907c3.952,1.142,6.657.2,10.961-.617a26.608,26.608,0,0,1,3.126-.49c.176.2.333.4.456.526.579.562,1.159,1.051,1.756,1.577.544.49,1.072,1.142,1.633,1.74a7.872,7.872,0,0,1,.7,1.867,13,13,0,0,1,.123,3.788c-.088,1.469-.176,3.01-.211,4.513-.053.562-.123,1.106-.158,1.7,0,.127.3.49.421.29a17,17,0,0,0,.984-2.41c.456-1.015.984-2.031,1.44-3.046a27.721,27.721,0,0,1,3.442-6.073c.826-1.015,2.635-2.737,1.844-4.224a1.481,1.481,0,0,0-.228-.49Z",
    transform: "translate(-114.534 -44.654)",
    fill: "#563629",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165146",
    "data-name": "Path 165146",
    d: "M401.327,90.594c.7.816,1.721,1.922,1.686,3.1a3.457,3.457,0,0,1-1.563,2.52,4.483,4.483,0,0,1-2.793,1.106c-.088,0-.176-.163-.088-.235.737-.725,1.6-1.251,2.249-1.994-2.723,1.577-6.358-.617-7.8-3.3-.176-.363-.527-1.051-.123-1.378.563-.49,1.475-.2,2.056.036a14.493,14.493,0,0,1,1.353.581l-.193-.2a26.392,26.392,0,0,0-2.793-1.9,2.788,2.788,0,0,1-1.159-2.194,4.352,4.352,0,0,1,.772-2.574c1.633-2.321,5.147-.924,6.938.979a7,7,0,0,0-3.319-2.974c-.984-.4-3-.979-3.584.326a.136.136,0,0,1-.246-.036,16.234,16.234,0,0,1-.333-3.915.15.15,0,0,1,.193-.127,4.841,4.841,0,0,0,4.145.453c.088-.036.211.091.158.2a3.571,3.571,0,0,1-1.633,1.269,9.012,9.012,0,0,1,5.182,3.173c.246.254.491.562.737.852a6.584,6.584,0,0,1,2.091,4.75,5.1,5.1,0,0,1-.632,2.52.143.143,0,0,1-.211.036,10.354,10.354,0,0,1-1.089-1.07Z",
    transform: "translate(-358.651 -74.199)",
    fill: "#774635"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165147",
    "data-name": "Path 165147",
    d: "M149.8,51.2a7,7,0,0,1,2.828.689c.211.091.4.2.614.29a7.335,7.335,0,0,1,2.951,2.719,7.1,7.1,0,0,1,.791,3.951,4.29,4.29,0,0,1-1.072,2.974,4.163,4.163,0,0,1-1.072.725,3.1,3.1,0,0,1-.7.49,9.494,9.494,0,0,1-3.039,1.251,19.3,19.3,0,0,1-6.991-.4c-4.075-.725-9.361-1.5-12.154,2.574-.088.127-.281.072-.246-.091a10.667,10.667,0,0,1,4.479-6.092,17.307,17.307,0,0,1,5.27-2.285,14.7,14.7,0,0,0-3.039.4,19.221,19.221,0,0,0-5.058,1.269,12.5,12.5,0,0,0-4.145,2.974c-.088.091-.246.29-.421.49a8.216,8.216,0,0,1,3.777-4.894c2.055-1.215,4.321-1.958,6.447-3.046.053-.036.158-.235.035-.2a33.844,33.844,0,0,0-6.2,2.23,9.47,9.47,0,0,0-2.635,1.051,7.551,7.551,0,0,0-3.584,3.915.128.128,0,1,1-.246-.072,9.2,9.2,0,0,1,3.407-5.819,10.8,10.8,0,0,1,5.252-2.158,10.46,10.46,0,0,0-5.638,1.74c-.123.091-.246-.091-.158-.235a8.673,8.673,0,0,1,6.868-3.263c1.51-.036,3,.326,4.514.29a2.716,2.716,0,0,1-2.547-1.958.13.13,0,0,1,.158-.163,4.718,4.718,0,0,0,3.2,0c1.037-.254,2.091-.581,3.161-.852a22.943,22.943,0,0,1,5.744-1.051,7.831,7.831,0,0,1,5.761,2.247,2.762,2.762,0,0,1,.949,2.81.127.127,0,0,1-.246,0c-.649-1.7-2.6-2.321-4.145-2.52a12.553,12.553,0,0,0-2.863.019Z",
    transform: "translate(-124.948 -48.143)",
    fill: "#774635"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165148",
    "data-name": "Path 165148",
    d: "M157.584,152.8c-1.388,1.668-2.6,3.462-4.145,5-.053.072-.246.036-.211-.091.158-1.342.053-2.719.176-4.061,0-.091.053-.163.158-.127.088.036.211.036.3.072a7.708,7.708,0,0,0-.861-1.015.135.135,0,0,1,.088-.235c.369-.036.772-.072,1.142-.127a8.921,8.921,0,0,1-2.6-1.269,11.762,11.762,0,0,1-3.091-3.209,8.793,8.793,0,0,1-1.019-3.462,6.809,6.809,0,0,1-1.563,1.867c-2.67,2.23-6.447,2.357-9.7,2.084-2.916-.235-5.884-1.051-8.835-.581a6.888,6.888,0,0,0-3.46,1.469,7.806,7.806,0,0,0-2.249,3.9.124.124,0,0,1-.246-.036,19.672,19.672,0,0,1,.176-2.9,14.754,14.754,0,0,0-.7,5.783.133.133,0,0,1-.246.072c-1.195-2.084-2.177-4.64-1.4-7a7.853,7.853,0,0,0-1.265,2.411.127.127,0,0,1-.246,0c-.456-2.737,1.019-5.365,3-7.088a11.492,11.492,0,0,0-1.9,1.469,5.689,5.689,0,0,0-2.056,3.589c0,.127-.246.2-.246.036v-.036h0a10.408,10.408,0,0,1,.949-5.819,7.609,7.609,0,0,0-1.353,3.372.135.135,0,0,1-.246.036,8.071,8.071,0,0,1-.667-4.714,4.754,4.754,0,0,0-.421,2.773,8.354,8.354,0,0,0,.984,2.647c-.158.254-.281.49-.421.744-.791,1.469,1.019,3.209,1.844,4.224a27.721,27.721,0,0,1,3.442,6.073c.491,1.015.984,2.031,1.44,3.046a21.274,21.274,0,0,0,.984,2.411c.123.2.421-.163.421-.29-.035-.562-.088-1.106-.158-1.7-.035-1.5-.123-3.01-.211-4.513a14.441,14.441,0,0,1,.123-3.788,8.485,8.485,0,0,1,1.019-2.448c.176-.163.333-.29.527-.453.826-.689,1.721-1.306,2.6-1.9.4-.254.772-.49,1.159-.725a21.566,21.566,0,0,1,4.812.907c3.952,1.142,6.657.2,10.961-.617a26.615,26.615,0,0,1,3.126-.49c.176.2.333.4.456.526.579.562,1.159,1.051,1.756,1.577.544.49,1.072,1.142,1.633,1.74a7.87,7.87,0,0,1,.7,1.867,13,13,0,0,1,.123,3.788c-.088,1.469-.176,3.01-.211,4.513-.053.562-.123,1.106-.158,1.7,0,.127.3.49.421.29a17,17,0,0,0,.984-2.41c.456-1.015.984-2.031,1.44-3.046a27.721,27.721,0,0,1,3.442-6.073c.667-.816,1.967-2.084,2.055-3.336a21.68,21.68,0,0,1-2.565,3.572Z",
    transform: "translate(-114.75 -130.04)",
    fill: "#563629",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165149",
    "data-name": "Path 165149",
    d: "M383.848,70.741c-.035-.072-.158.036-.158.091a52.887,52.887,0,0,1-.158,13.015c-.035.163.176.036.211-.036.649-2.031.544-4.551.614-6.707A23.628,23.628,0,0,0,383.848,70.741Z",
    transform: "translate(-351.06 -67.47)",
    fill: "#563629"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25049",
    "data-name": "Group 25049",
    transform: "translate(2.506 0.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165150",
    "data-name": "Path 165150",
    d: "M205.4,154.219c-1.528,1.106-4.058,1.106-5.831,1.142a44.409,44.409,0,0,1-5.744-.617,20.524,20.524,0,0,0-5.27-.235,8.222,8.222,0,0,0-3.705,1.867c-.088.072-.053.235.053.163a10.127,10.127,0,0,1,5.515-1.414,59.9,59.9,0,0,1,5.989.617,15.735,15.735,0,0,0,5.217,0c1.142-.2,3.039-.526,3.812-1.5C205.519,154.219,205.484,154.147,205.4,154.219Z",
    transform: "translate(-178.822 -141.303)",
    fill: "#563629",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165151",
    "data-name": "Path 165151",
    d: "M161.405,120.394a25.321,25.321,0,0,1,2.424-.744,10.45,10.45,0,0,0-7.078,3.082,4.653,4.653,0,0,0-.491.816c.035,0,.035-.036.053-.036a10.348,10.348,0,0,1,3.987-2.61,3.4,3.4,0,0,1,1.107-.507Z",
    transform: "translate(-153.73 -111.068)",
    fill: "#563629",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165152",
    "data-name": "Path 165152",
    d: "M135.3,110.113a.3.3,0,0,0,.053-.072,9.813,9.813,0,0,1,2-1.577,18.264,18.264,0,0,1,4.882-2.194C139.691,106.741,136.758,107.684,135.3,110.113Z",
    transform: "translate(-135.3 -99.354)",
    fill: "#563629",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165153",
    "data-name": "Path 165153",
    d: "M409.223,180.918a5.726,5.726,0,0,1-4.689-.4,11.046,11.046,0,0,1-3.126-3.3c-.035-.036-.088.036-.088.072.614,3.589,5.005,5,7.886,3.788.053-.036.14-.2.018-.163Z",
    transform: "translate(-369.212 -161.458)",
    fill: "#563629",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165154",
    "data-name": "Path 165154",
    d: "M240.681,51.309a6.98,6.98,0,0,1,2.389.235,9.451,9.451,0,0,0-6.657-.363c-.667.163-1.353.363-2.019.562-.333.127-.7.254-1.037.4a8.778,8.778,0,0,1-2.916.943,7.571,7.571,0,0,1-2.3-.127c1.756,1.015,4.356-.127,6.077-.581a21.31,21.31,0,0,1,6.463-1.07Z",
    transform: "translate(-216.934 -50.756)",
    fill: "#563629",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165155",
    "data-name": "Path 165155",
    d: "M450.781,167.168a4.317,4.317,0,0,0-2-1.433c-.053-.036-.176.091-.123.127a10.541,10.541,0,0,1,1.633,1.378,9.749,9.749,0,0,1,1.6,3.1c.053.127.246-.072.211-.163a6.8,6.8,0,0,0-1.317-3.01Z",
    transform: "translate(-410.822 -151.406)",
    fill: "#563629",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165156",
    "data-name": "Path 165156",
    d: "M464.55,129.562c-.053-.072-.211.072-.158.163a11.252,11.252,0,0,1,1.475,4.188,13.79,13.79,0,0,0-1.23-2.031c-.053-.091-.211.091-.176.163a14.27,14.27,0,0,1,.914,1.958c.281.689.3,1.378.544,2.067.053.2.281-.072.3-.163a1.826,1.826,0,0,0,0-.617c.6-1.994-.527-4.188-1.668-5.728Z",
    transform: "translate(-424.661 -119.728)",
    fill: "#563629",
    opacity: 0.8
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoyImage);
export default __webpack_public_path__ + "static/media/boyImage.fbe352db0f42b0a3ce47c7f189b933ea.svg";
export { ForwardRef as ReactComponent };